import { render, staticRenderFns } from "./StatisticsTeacher.vue?vue&type=template&id=b482efe6&scoped=true&"
import script from "./StatisticsTeacher.vue?vue&type=script&lang=js&"
export * from "./StatisticsTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b482efe6",
  null
  
)

export default component.exports